import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1832">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1833">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1834">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1835">
          {isOpen ? <XIcon size={24} data-id="element-1836" /> : <PlusIcon size={24} data-id="element-1837" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1838">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1839">
          {answer}
        </p>
      </div>
    </div>;
}
export function SCFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'How Is Sculptra Different Than Other Fillers?',
    answer: 'Sculptra is different from other dermal fillers in a couple of ways. First, its main active ingredient is poly-L-lactic acid rather than hyaluronic acid. Although hyaluronic acid may also promote collagen production, PLLA is a clinically proven collagen stimulator. Second, Sculptra can last up to 2 years, whereas dermal fillers like Juvéderm and Restylane last for about a year.'
  }, {
    question: 'How Long Will It Take To See Results?',
    answer: 'You will notice your Sculptra results throughout the following weeks and months after your injections. If you appear the same directly after your treatment, do not get discouraged. Sculptra does not provide immediate results like dermal fillers; however, the long-term benefits are well worth the wait.'
  }, {
    question: 'How Many Sessions of Sculptra Will I Need?',
    answer: "The number of Sculptra sessions required can vary depending on individual factors, such as the desired outcome, the severity of concerns and the individual's response to the treatment. In general, a series of multiple sessions is typically recommended to achieve optimal results with Sculptra. On average, most patients undergo three to four treatment sessions, spaced about four to six weeks apart. This interval allows for sufficient collagen stimulation and gradual improvement in the treated areas."
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1840">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1841">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1842">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1843">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1844"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1845">
          <div className="space-y-2" data-id="element-1846">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1847" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}